<script setup lang="ts">
import { renderMarkdown } from '../../../utils/markdown'

withDefaults(
  defineProps<{
    /** Raw markdown source, typically model-generated. */
    content: string
    /** Shows a pulsing caret after the content while a response is streaming in. */
    streaming?: boolean
  }>(),
  {
    streaming: false,
  },
)
</script>

<template>
  <!-- v-html is safe: renderMarkdown() escapes raw HTML (MarkdownIt `html: false`). -->
  <div class="prose-response text-body text-text-primary" v-html="renderMarkdown(content)" />
  <span
    v-if="streaming"
    class="ml-1 inline-block text-text-tertiary motion-safe:animate-typing"
    aria-hidden="true"
  >
    ▍
  </span>
</template>
